import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { BasicField } from '~src/spacesPlatform/components/tooltip/BasicField';
import { Name } from '~src/spacesPlatform/components/tooltip/Name';
import { Timestamp } from '~src/spacesPlatform/components/tooltip/Timestamp';
import { Tooltip } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { ContentTooltipProps, TooltipDescriptionTestId } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { IContentRelayPlanInfo } from '../models/IContentRelayPlanInfo';

/**
 * The grid-view info popover for a Content Relay plan: name (linked to the plan detail), description,
 * owner and last-modified time. See W-23846058.
 *
 * NOTE: `listPlans` returns only `ownerId` (a numeric user id), not an owner display name, so the
 * Owner field falls back to `ownerId` here. Once the backend contract exposes the owner (W-23846068),
 * this can switch to the linked <User> field like WorkbookTooltip.
 */
export function ContentRelayPlanTooltip(props: ContentTooltipProps): JSX.Element {
  const content = props.content as IContentRelayPlanInfo;
  const owner = (content.owner && content.owner.displayName) || content.ownerId;
  return (
    <Tooltip>
      <Name name={content.name} url={props.contentUrl} />
      <MarkupField markup={content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <dl className={DetailsTooltipStyles.DescriptionList}>
        <BasicField name={Messages.owner()} value={owner} />
        {content.updatedAt && <Timestamp label={Messages.modified()} value={content.updatedAt} />}
      </dl>
    </Tooltip>
  );
}
